document.addEventListener('DOMContentLoaded', function () {
  const caratVariantGroup = document.querySelector(
    '.variant-group[data-option-name="Center Stone Carat"]'
  );

  const stoneCard = document.querySelector(
    '.setting-details-card.stone-card'
  );

  if (!caratVariantGroup || !stoneCard) return;

  const caratSpecBox = Array.from(
    stoneCard.querySelectorAll('.spec-box')
  ).find(function (specBox) {
    const label = specBox.querySelector('.spec-label');

    return (
      label &&
      label.textContent.trim().toUpperCase() === 'CARAT'
    );
  });

  const caratValueElement = caratSpecBox
    ? caratSpecBox.querySelector('.spec-value')
    : null;

  const selectedValueElement = caratVariantGroup.querySelector(
    '.variant-label .option-selected-val'
  );

  if (!caratValueElement || !selectedValueElement) return;

  function updateCaratValue(value) {
    const caratValue = String(value || '').trim();

    if (caratValue) {
      caratValueElement.textContent = caratValue;
    }
  }

  function syncCaratFromSelectedOption() {
    const selectedCarat = selectedValueElement.textContent.trim();

    if (selectedCarat) {
      updateCaratValue(selectedCarat);
      return;
    }

    const activeButton = caratVariantGroup.querySelector(
      '.pill-btn.option-btn.active[data-value]'
    );

    if (activeButton) {
      updateCaratValue(activeButton.dataset.value);
    }
  }

  // Updates immediately using the currently selected Carat.
  syncCaratFromSelectedOption();

  // Handles Shopify/theme scripts that apply the selected variation after load.
  window.setTimeout(syncCaratFromSelectedOption, 100);
  window.setTimeout(syncCaratFromSelectedOption, 500);
  window.setTimeout(syncCaratFromSelectedOption, 1000);

  // Updates when the customer clicks a Carat option.
  caratVariantGroup.addEventListener('click', function (event) {
    const selectedButton = event.target.closest(
      '.pill-btn.option-btn[data-value]'
    );

    if (!selectedButton || !caratVariantGroup.contains(selectedButton)) {
      return;
    }

    updateCaratValue(selectedButton.dataset.value);

    window.setTimeout(syncCaratFromSelectedOption, 50);
  });

  // Watches the selected-value text for updates made by your variant script.
  const selectedValueObserver = new MutationObserver(function () {
    syncCaratFromSelectedOption();
  });

  selectedValueObserver.observe(selectedValueElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
});